<template>
  <validation-observer v-slot="{ handleSubmit }">
    <div class="row">
      <div class="col-md-12 text-bold bold mb-3">
        <i class=" fas fa-redo-alt color-primary-1" />
        Devolución
      </div>
      <div class="col-md-4">
        <validation-provider v-slot="{ errors }" rules="required">
          <custom-date-picker
            v-model="model.returnDate"
            class-container="w-100"
            custom-error-msg="La fecha es requerida."
            :error="errors[0]"
            label="Fecha:"
            :max-date="new Date()"
            placeholder="DD/MM/YYYY"
          />
        </validation-provider>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12 mt-2">
        <validation-provider v-slot="{ errors }" rules="required">
          <custom-text-area
            v-model="model.returnComment"
            custom-error-msg="El comentario es requerido."
            :error="errors[0]"
            label="Comentario:"
            :maxlength="3000"
            :rows="4"
            show-char-count
          />
        </validation-provider>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12 text-right mt-3 pt-1">
        <action-button
          i="fas fa-times-circle"
          text="Cancelar"
          variant="outline-danger mr-3"
          @click="$emit('on-cancel')"
        />
        <action-button
          i="fas fa-save"
          text="Guardar"
          variant="success"
          @click="handleSubmit(submit)"
        />
      </div>
    </div>
  </validation-observer>
</template>

<script>
import CustomTextArea from 'CustomTextArea';
import CustomDatePicker from 'custom-date-picker';
import alertMixin from '@/mixins/alert.mixin';
import { putCardReturn } from '@/modules/shared/cardHandling.api';
export default {
  name: 'ReturnCard',
  components: {
    CustomTextArea,
    CustomDatePicker,
  },
  mixins: [alertMixin],
  props: {
    id: {
      type: Number,
      default: 0,
      require: true,
    },
  },
  data: () => ({
    model: {},
  }),
  methods: {
    async submit() {
      this.model.becaCardId = this.id;

      await putCardReturn(this.model)
        .then(() => {
          this.ShowToast(
            'Confirmación',
            'La devolución ha sido realizada exitosamente.',
            'success'
          );
          this.$emit('on-saved');
        })
        .catch((err) => {
          if (err && err.response && err.response.data) {
            this.ShowToast('Error', err.response.data.message, 'error');
          } else {
            this.ShowToast('Error', err.message, 'error');
          }
        });
    },
  },
};
</script>
<style scoped lang="scss">
@use "sass:map";
@import '@/shared/scss/config/_colors.scss';

::v-deep .input-group-prepend.success .input-group-text {
  background: map.get($colors, 'green') !important;
  color: map.get($colors, 'white') !important;
}
</style>
